//css-------------------
import "../../css/home/welcome.scss";
import "@/css/share/_reset.scss";
import "@/css/share/_base.scss";
import "@/css/share/_share.scss";
import "@/css/share/components/_lightbox.scss";
import "@/css/share/components/_backtotop.scss";
import "@/css/share/components/_loading.scss";
import "@/css/share/components/_header.scss";
import "@/css/share/components/_footer.scss";
import "@/css/share/components/_input.scss";
import "@/css/share/components/_maintitle.scss";
import "@/css/share/components/_swiper.scss";
import "@/css/share/components/_item.scss";
import "@/css/share/components/_item_theme_1.scss";
import "@/css/share/components/_item_theme_2.scss";
import "@/css/share/components/_item_theme_3.scss";
import "@/css/share/components/_item_theme_4.scss";
import "@/css/share/components/_item_theme_5.scss";
import "@/css/share/components/_readmore_btn.scss";
import "@/css/share/components/_linkto_btn.scss";
import "@/css/share/components/_list_col.scss";

// //swiper
import(/* webpackPrefetch: true */ "swiper/css");
import(/* webpackPrefetch: true */ "swiper/css/pagination");
import(/* webpackPrefetch: true */ "swiper/css/effect-fade");
// import(/* webpackPrefetch: true */ "swiper/css/navigation"); 

// //fontawesome
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/fontawesome.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/brands.min.css");

//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_backtotop");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import { subnav_show, subnav_hide, subnav_toggle, m_menu_open } from "@/js/share/components/_header";
import { init_imageloaded } from "@/js/share/components/_imageloader.js";

//npm lib  
import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import imagesLoaded from "imagesloaded";
import Swiper from "swiper";
import { Pagination, Navigation, Autoplay, EffectFade } from "swiper/modules";
import { createApp } from "vue/dist/vue.esm-browser.prod.js";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

const app = createApp({
    data() {
        return {
            menu_open: false,
            count_obj: [{
                value: 0,
                count_to: count_to_1,
            }, {
                value: 0,
                count_to: count_to_2,
            }, {
                value: 0,
                count_to: count_to_3,
            }, {
                value: 0,
                count_to: count_to_4,
            }],
        };
    },
    watch: {
        menu_open: m_menu_open(this),
    },
    mounted() {
        const _this = this;
        init_imageloaded(function () {
            _this.init_kv_swiper();
            _this.init_event_swiper();
            _this.init_community_swiper();
            _this.init_program_swiper();
            _this.scroll_ani();
        });
    },
    methods: {
        subnav_show,
        subnav_hide,
        subnav_toggle,
        init_kv_swiper() {
            let _loop = false;
            if ($('.kv_swiper').find('.swiper-slide').length > 1) {
                _loop = true;
            }
            new Swiper(".kv_swiper .swiper", {
                modules: [Pagination, Navigation, Autoplay],
                slidesPerView: 1,
                grabCursor: true,
                speed: 800,
                loop: _loop,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });
        },
        init_event_swiper() {
            new Swiper(".event_swiper .swiper", {
                modules: [Pagination, Navigation],
                slidesPerView: 3,
                grabCursor: true,
                navigation: {
                    nextEl: ".event_swiper .swiper-button-next",
                    prevEl: ".event_swiper .swiper-button-prev",
                },
                pagination: {
                    el: ".event_swiper .swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    950: {
                        slidesPerView: 3,
                    }
                }
            });
        },
        init_community_swiper() {
            new Swiper(".community_swiper .swiper", {
                modules: [Pagination, Navigation],
                slidesPerView: 3,
                initialSlide: 3,
                centeredSlides: true,
                grabCursor: true,
                navigation: {
                    nextEl: ".community_swiper .swiper-button-next",
                    prevEl: ".community_swiper .swiper-button-prev",
                },
                pagination: {
                    el: ".community_swiper .swiper-pagination",
                    clickable: true,
                },
            });
        },
        init_program_swiper() {
            new Swiper(".program_swiper .swiper", {
                modules: [Pagination, Navigation],
                slidesPerView: 3.35,
                grabCursor: true,
                navigation: {
                    nextEl: ".program_swiper .swiper-button-next",
                    prevEl: ".program_swiper .swiper-button-prev",
                },
                pagination: {
                    el: ".program_swiper .swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                    },
                    680: {
                        slidesPerView: 1.35,
                    },
                    950: {
                        slidesPerView: 3.35,
                    }
                }
            });
        },
        scroll_ani() {
            const winW = $(window).width();

            gsap.timeline()
                .from('.main_navli', { stagger: .15, duration: .7, x: 50, opacity: 0, ease: 'quart.out' })

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.news_sec',
                    start: "top center",// when the top of the trigger hits the top of the viewport
                    end: '+=1000',
                }
            })
                .from('.news_sec .maintitle_row', { duration: .7, opacity: 0, x: -50, ease: 'quart.out' })
                .add('sametime1', '-=.5')
                .from('.news_left .item_box', { duration: .7, opacity: 0, x: -50, ease: 'quart.out' }, 'sametime1')
                .from('.news_right .item_row', { duration: .7, stagger: .2, opacity: 0, x: 100, ease: 'quart.out' }, 'sametime1')
                .from('.news_sec .readmore_btn', { duration: .7, opacity: 0, x: 100, ease: 'quart.out' }, '-=.2')

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.about_sec',
                    start: "top 80%",// when the top of the trigger hits the top of the viewport
                    end: '+=1000',
                }
            })
                .from('.about_pic_left', { duration: 1.2, opacity: 0, y: 250, ease: 'quart.out' })
                .from('.about_pic_right', { duration: 1.2, opacity: 0, y: 250, ease: 'quart.out' }, '-=1')
                .from('.about_center', { duration: 1.2, opacity: 0, y: 450, ease: 'quart.out' }, '-=.6')

            // if (winW > 950) {
            //     const _about_sec_ani = gsap.timeline();
            //     ScrollTrigger.create({
            //         animation: _about_sec_ani,
            //         trigger: '.about_sec',
            //         start: "top 20%",
            //         end: "+=700",
            //         scrub: 1,
            //         pin: true,
            //         anticipatePin: 1
            //     })
            //     _about_sec_ani.from('.about_center', { duration: .8, opacity: 0, y: 250, ease: 'power1.out' })
            //         .to('.about_pic_right', { duration: .8, opacity: 0, y: -150, ease: 'power0.out' }, '+=1')
            //         .to('.about_pic_left', { duration: .8, opacity: 0, y: -150, ease: 'power0.out' }, '-=.2')
            //         .to('.about_center', { duration: .8, opacity: 0, y: -250, ease: 'power0.out' }, '-=.2')

            // }

            gsap.timeline({
                scrollTrigger: {
                    trigger: ".count_sec",
                    start: "top 80%",
                    end: "bottom 50%",
                    toggleActions: "restart none none none"
                },
            })
                .to(this.count_obj[0], {
                    value: this.count_obj[0].count_to,
                    roundProps: {
                        value: 1
                    },
                    duration: 2,
                    ease: 'power0.out',
                })
                .to(this.count_obj[1], {
                    value: this.count_obj[1].count_to,
                    roundProps: {
                        value: 1
                    },
                    duration: 2,
                    ease: 'power0.out',
                }, '-=1.7')
                .to(this.count_obj[2], {
                    value: this.count_obj[2].count_to,
                    roundProps: {
                        value: 1
                    },
                    duration: 2,
                    ease: 'power0.out',
                }, '-=1.7')
                .to(this.count_obj[3], {
                    value: this.count_obj[3].count_to,
                    roundProps: {
                        value: 1
                    },
                    duration: 2,
                    ease: 'power0.out',
                }, '-=1.7')


            gsap.timeline({
                scrollTrigger: {
                    trigger: '.event_sec',
                    start: "top center",// when the top of the trigger hits the top of the viewport
                    end: '+=1000',
                }
            })
                .from('.event_sec .maintitle_row', { duration: .7, opacity: 0, x: -50, ease: 'quart.out' })
                .add('sametime1', '-=.5')
                .from('.event_sec .item', { duration: .7, stagger: .2, opacity: 0, x: -50, ease: 'quart.out' }, 'sametime1')
                .from('.event_sec .readmore_btn', { duration: .7, opacity: 0, x: -50, ease: 'quart.out' }, '-=.2')


            gsap.timeline({
                scrollTrigger: {
                    trigger: '.community_sec',
                    start: "top center",// when the top of the trigger hits the top of the viewport
                    end: '+=1000',
                }
            })
                .from('.community_board', { duration: .7, opacity: 0, y: 50, ease: 'quart.out' })
                .from('.community_board .maintitle_row', { duration: .7, opacity: 0, y: 50, ease: 'quart.out' }, '-=.5')
                .from('.community_board .community_txt', { duration: .7, opacity: 0, y: 50, ease: 'quart.out' }, '-=.5')
                .from('.community_sec .community_pic', { duration: .7, stagger: .15, opacity: 0, y: 50, ease: 'quart.out' }, '-=.3')


            gsap.timeline({
                scrollTrigger: {
                    trigger: '.program_sec',
                    start: "top center",// when the top of the trigger hits the top of the viewport
                    end: '+=1000',
                }
            })
                .from('.program_sec .maintitle_row', { duration: .7, opacity: 0, y: 50, ease: 'quart.out' })
                .from('.program_sec .item.theme_5', { duration: .7, opacity: 0, y: 70, ease: 'quart.out' }, '-=.4')
                .from('.program_sec .readmore_btn', { duration: .7, opacity: 0, y: 50, ease: 'quart.out' }, '-=.2')
        },
    },
}).mount("#app");
